import * as React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AddCard from "./Pages/AddCard/AddCard";
import DeleteAccount from "./Pages/DeleteAccount/DeleteAccount";
import PlaidRedirect from "./Pages/PlaidRediect/PlaidRedirect";
import CardSuccess from "./Pages/CardSuccess/CardSuccess";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import TransactionLogs from "./Pages/TransactionLogs/TransactionLogs";
import UserLogs from "./Pages/UserLogs/UserLogs";
import Compliance from "./Pages/Compliance/Compliance";
import UserDetails from "./Pages/UserDetails/UserDetails";
import UserVerification from "./Pages/UserVerification/UserVerification";
import UserVerificationSuccess from "./Pages/UserVerification/UserVerificationSuccess";
import UserVerificationFailure from "./Pages/UserVerification/UserVerificationFailure";
import UserReports from "./Pages/Reports/UserReports";
import PromoCodes from "./Pages/PromoCode/PromoCode";
import Referrals from "./Pages/Referrals/ReferralsMain";
import ExchangeRate from "./Pages/ExchangeRate/ExchangeRate";
import ChargeBackInfo from "./Pages/ChargeBackInfo/ChargeBackInfo";
import Partner from "./Pages/Partner/Partner";
import RateReconciliation from "./Pages/PlaceholderRateReconciliation/RateReconciliation";
import FXReports from './Pages/FXReports/FXReports';
import FxPoolsMainPage from "./Pages/FxAllocation/FxPoolsMainPage";
import FxAllocationList from "./Pages/FxAllocation/FxAllocationList/FxAllocationList";
import FxPurchaseDetail from "./Pages/FxAllocation/FxPurchaseDetail/FxPurchaseDetail";
import BankPartners from "./Pages/NavBar/BankPartners.tsx/BankPartnersList";
import Networks from "./Pages/NavBar/Networks/NetworkList";


// Define public routes
const publicRoutes = [
    { path: "/deleteaccount", component: <DeleteAccount /> },
    { path: "/addcard", component: <AddCard /> },
    { path: "/plaid", component: <PlaidRedirect /> },
    { path: "/cardsuccess", component: <CardSuccess /> },
    { path: "/userVerification/:id?", component: <UserVerification /> },
    { path: "/userVerificationSuccess", component: <UserVerificationSuccess /> },
    { path: "/userVerificationFailure", component: <UserVerificationFailure /> },
    { path: "/", component: <Login /> },
    { path: "/ratereconciliation", component: <RateReconciliation /> },
    { path: "/fxreports", component: <FXReports /> },
    { path: "/bankpartners", component: <BankPartners /> },
    { path: "/networks", component: <Networks /> },
];

// Define protected routes
const protectedRoutes = [
    { path: "/dashboard", component: <Dashboard /> },
    { path: "/transactionlogs/:id?", component: <TransactionLogs /> },
    { path: "/useractions/", component: <UserLogs /> },
    { path: "/compliance", component: <Compliance /> },
    { path: "/userdetails/:email?", component: <UserDetails /> },
    { path: "/userreports", component: <UserReports /> },
    { path: "/promocode", component: <PromoCodes /> },
    { path: "/referral", component: <Referrals /> },
    { path: "/exchangerate", component: <ExchangeRate /> },
    { path: "/chargeback", component: <ChargeBackInfo /> },
    { path: "/partner", component: <Partner /> },
    { path: "/fxpools", component: <FxPoolsMainPage /> },
    { path: "/fxallocations", component: <FxAllocationList /> },
    {
        path: "/fxpooldetails", component: <FxPurchaseDetail open={false} onClose={function (): void {
            throw new Error("Function not implemented.");
        }} refreshData={function (): void {
            throw new Error("Function not implemented.");
        }} />
    }
];

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            {publicRoutes.map(({ path, component }) => (
                <Route key={path} path={path} element={component} />
            ))}

            {/* Protected Routes */}
            {protectedRoutes.map(({ path, component }) => (
                <Route
                    key={path}
                    path={path}
                    element={<ProtectedRoute>{component}</ProtectedRoute>}
                />
            ))}
        </Routes>
    );
};

export default AppRoutes;
